const env = process.env.NODE_ENV;

const configs = {
  production: {
    callback_uri:
      process.env.STRAVA_CALLBACK_URI || "https://www.mapperbike.com",
    redirect_url:
      process.env.STRAVA_REDIRECT_URL || "https://www.mapperbike.com",
  },
  dev: {
    callback_uri: "http://localhost:3000",
    redirect_url: "http://localhost:8080",
  },
  test: {
    callback_uri: "http://localhost:8080",
    redirect_url: "http://localhost:8080",
  },
};
console.log("process.env: ", process.env);

const keys = configs[env] || configs.dev;

keys.client_id = process.env.REACT_APP_STRAVA_CLIENT_ID;
keys.client_secret = process.env.STRAVA_CLIENT_SECRET;
keys.client_refresh = process.env.STRAVA_CLIENT_REFRESH;
keys.secretSuperKey = process.env.SECRET_SUPER_KEY;
keys.mapsApi = process.env.REACT_APP_MAPS_API;
keys.subscriptionId = process.env.STRAVA_SUBSCRIPTION_ID;
keys.sbmtPassword = process.env.SBMT_PASSWORD;

const dbTableNames = {
  production: {
    activities: "activities",
    segmentEfforts: "segmentEfforts",
    segmentDetails: "segmentDetails",
    users: "users",
  },
  test: {
    activities: "activities-dev",
    segmentEfforts: "segmentEfforts-dev",
    segmentDetails: "segmentDetails-dev",
    users: "users-dev",
  },
  dev: {
    activities: "activities-dev",
    segmentEfforts: "segmentEfforts-dev",
    segmentDetails: "segmentDetails-dev",
    users: "users-dev",
  },
};

keys.dbTables = dbTableNames[env] || dbTableNames.dev;

module.exports = keys;
